import {Dispatch, MiddlewareAPI, UnknownAction} from "redux";
import {keycloakMiddleware} from "./keycloak";
import reducer, {State} from "./reducer";
import {Action, isActionWithPayload} from "./action/utils";
import {createEpicMiddleware} from 'redux-observable';
import {rootEpic} from "./epic";
import axios, {AxiosInstance} from "axios";
import {baseApiUrl} from "./const";
import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { MemoryHistory, createMemoryHistory } from "history";


export type EpicDependencies = {
    axios: AxiosInstance,
    history: MemoryHistory
}

const loggerMiddleware = (_: MiddlewareAPI<any>) => (next: Dispatch<UnknownAction>) => (action: Action) => {
    if (isActionWithPayload(action)) {
        console.log('action', action.type, action.payload);
    } else {
        console.log('action', action.type);
    }
    return next(action);
};

export const axiosInstance = axios.create(
    {
        timeout: 30000,
        baseURL: baseApiUrl,
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        }
    }
)
const history = createMemoryHistory();

const epicMiddleware = createEpicMiddleware<any, any, State, EpicDependencies>({
    dependencies: {
        axios: axiosInstance,
        history
    }
});

const middleware = (getDefaultMiddleware: any) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat([loggerMiddleware, keycloakMiddleware, epicMiddleware])

const store = configureStore({
    reducer: reducer,
    middleware: middleware
  })

epicMiddleware.run(rootEpic);

export default store

export type AppDispatch = typeof store.dispatch
export const useAppDispatch = useDispatch.withTypes<AppDispatch>() // Export a hook that can be reused to resolve types


